import environment from './environment';

const buildUri = (endpoint, uri) => (endpoint ? `${endpoint}/${uri}` : undefined);

export const toInsecureApiUri = uri => buildUri(environment.api_insecure, uri);
export const toSecureApiUri = uri => buildUri(environment.api_secure, uri);



// WEBPACK FOOTER //
// ./src/utils/url.js